import { SiteUrls } from '@tableau/shared-urls';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { TooltipAnchor } from '../../app/spaces/Tooltips/TooltipAnchor';
import { Formatters, Messages } from '../../codegen/Localize';
import { classes, cssClass } from '../../style';
import { RunFlowTaskStatus } from '../../ts/models/RunFlowTaskInfo';
import { getRunFlowTaskStatusIconClass } from '../utils/FlowIconUtils';

const cssPrefix = 'FlowSuspendedIconWithTooltip';

export const tooltipMessage = cssClass(cssPrefix, 'tooltipMessage', {
  paddingTop: TabStyles.Spacing.DefaultSpace,
  wordWrap: 'break-word',
});

export const suspendedIcon = cssClass(cssPrefix, 'scheduleSuspendedIcon', {
  paddingRight: 4,
  flexShrink: 0
});

const scheduledTasksLink = cssClass(cssPrefix, 'scheduledTasksLink', {
  paddingTop: TabStyles.Spacing.DefaultSpace,
});

export type FlowSuspendedIconWithTooltipProps = {
  readonly flowId?: string;
  readonly flowFailureThresholdForRunPrevention?: number
  readonly suspendedTasksCount?: number
  readonly siteUrls?: SiteUrls;
  readonly isForHeader?: boolean;
  readonly urlName?: string; // used to ensure we get the right siteUrl for a row
};

export class FlowSuspendedIconWithTooltip extends React.PureComponent<FlowSuspendedIconWithTooltipProps> {
  private shouldRenderScheduledTasksLink: boolean;

  constructor(props: FlowSuspendedIconWithTooltipProps) {
    super(props);
    this.shouldRenderScheduledTasksLink = props.flowId && !!props.siteUrls;
  }

  private getTooltipContent = () => {
    return (
      <div>
        <div className={'tb-content-item-popover-title'}>
          {this.props.suspendedTasksCount && this.props.suspendedTasksCount > 1 ? Messages.flowTaskSuspendedTooltipTitleMultiple() : Messages.flowTaskSuspendedTooltipTitle()}
        </div>
        <div className={tooltipMessage}>
          {this.getTooltipContentMessage()}
        </div>
        {this.shouldRenderScheduledTasksLink ? this.renderScheduledTasksLink() : null}
      </div>
    );
  }

  private getTooltipContentMessage = (): string => {
    if (this.props.isForHeader && this.props.suspendedTasksCount) {
      return Messages.suspendedJobFailureFlows({COUNT: this.props.suspendedTasksCount,
        COUNT_LOC: Formatters.formatCount(this.props.flowFailureThresholdForRunPrevention)});
    } else if (this.props.suspendedTasksCount) {
      return Messages.flowTasksSuspendedCountOutput({SUSPENDED_TASK_COUNT: this.props.suspendedTasksCount,
        SUSPENDED_TASK_COUNT_LOC: Formatters.formatCount(this.props.suspendedTasksCount)});
    } else if (this.props.flowFailureThresholdForRunPrevention && this.props.flowFailureThresholdForRunPrevention > 0) {
      return Messages.flowTaskSuspendedTooltipMessageCount({FAILURE_COUNT_LOC: Formatters.formatCount(this.props.flowFailureThresholdForRunPrevention)});
    } else {
      return Messages.flowTaskSuspendedTooltipMessage();
    }
  }

  private renderScheduledTasksLink = () => {
    const siteUrlsForRow = this.props.urlName != null ? this.props.siteUrls.forSiteName(this.props.urlName) : this.props.siteUrls; // 'default' site urlName is empty string
    return (
      <div className={scheduledTasksLink}>
        <a href={siteUrlsForRow.flowScheduledTasksUrl(this.props.flowId)}>
          {Messages.scheduledTasksGoToScheduledTasks()}
        </a>
      </div>);
  }

  public render() {
    return (
    <TooltipAnchor
      tooltipContent={this.getTooltipContent}
      width={264} // 300 - (36 padding) = renders at 300
      delay={0}
      disableAutoFocus={!this.shouldRenderScheduledTasksLink}
      title={Messages.suspendedTasksTooltipTitle()}>
        <div className={classes(getRunFlowTaskStatusIconClass(RunFlowTaskStatus.Suspended), suspendedIcon)}/>
    </TooltipAnchor>);
  }
}

